import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { RtrButtonComponent } from '@rtr-factory/ui/button';
import { DialogWrapperComponent } from '@rtr-factory/ui/dialog';
import { User, UserRole, UserRoleName } from 'rio-core';

@Component({
  selector: 'app-edit-user-dialog',
  templateUrl: './edit-user-dialog.component.html',
  styleUrl: './edit-user-dialog.component.scss',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    DialogWrapperComponent,
    ReactiveFormsModule,
    RtrButtonComponent,
  ],
})
export class EditUserDialogComponent {
  dialogRef = inject(MatDialogRef<EditUserDialogComponent>);
  data: { details: User; role: UserRole } = inject(MAT_DIALOG_DATA);

  UserRoleName = UserRoleName;

  cancel() {
    this.dialogRef.close();
  }
}
